import referralService from "../services/referralInvites.service";
import {
  LOAD_REFERRAL_SKELETON,
  SET_SUCCESS_MESSAGE,
  SET_FAILED_MESSAGE,
  GET_REFERRAL_LIST,
} from "./types";

export const getReferralListAction = () => async (dispatch) => {
  dispatch({ type: LOAD_REFERRAL_SKELETON, payload: true });
  return await referralService.getReferralInvites().then((resp) => {
    dispatch({
      type: GET_REFERRAL_LIST,
      payload: resp.status ? resp.data : [],
    });
  });
};

export const addIndividualReferralAction = (payload) => (dispatch) => {
  return referralService.addIndividualReferral(payload).then((resp) => {
    if (resp.status) {
      dispatch(getReferralListAction());
      dispatch({ type: SET_SUCCESS_MESSAGE, payload: resp.data });
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
  });
};

export const removeIndividualInviteAction = (id) => (dispatch) => {
  return referralService.removeIndividualInvite(id).then((resp) => {
    if (resp.status) {
      dispatch(getReferralListAction());
      dispatch({ type: SET_SUCCESS_MESSAGE, payload: resp.data });
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
  });
};
